import React from "react"
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux"
import { Typography, Box, List, ListItem, ListItemText, ListItemSecondaryAction, IconButton } from "@material-ui/core"
import { makeStyles, useTheme } from "@material-ui/core/styles"
import MultiTagDialog from "../common/dialog/Simple"
import { CONTEXT_TYPE } from "../../utils"
import { updateFileTag } from "../../actions/documentsActions"

const useStyles = makeStyles((theme) => ({
	multiTagDialog: {
		"& .MuiDialogContent-root": {
			paddingTop: 0,
		},
		"& .MuiListItemText-primary": {
			fontSize: theme.typography.fontSize,
			textTransform: "capitalize",
			maxWidth: 140,
			textOverflow: "ellipsis",
			overflow: "hidden",
			whiteSpace: "nowrap",
		},
		"& .MuiListItem-root": {
			padding: 0,
		},
		"& .MuiListItemIcon-root": {
			minWidth: "20px",
			color: theme.palette.grey[300],
		},
		"& .MuiSvgIcon-fontSizeSmall": {
			fontSize: theme.typography.fontSize,
		},
		"& .MuiListItemSecondaryAction-root": {
			maxWidth: 150,
		},
	},
	removeTagButton: {
		fontSize: theme.typography.fontSize,
		color: theme.palette.grey["D100"],
	},
	appliedBy: {
		fontStyle: "italic",
		color: theme.palette.grey["D100"],
	},
}))

function ShowAllTags(props) {
	const classes = useStyles()
	const theme = useTheme()
	const [t] = useTranslation("global")
	const dispatch = useDispatch()
	const {
		multiTagDialogOpen,
		multiTagDialogData,
		setMultiTagDialogOpen,
		setMultiTagDialogData,
		selectedSearch,
		setCurrFileId,
		currFileId,
	} = props?.tagState
	const { tags } = useSelector((state) => state?.tags?.custom_tags)
	const { user } = useSelector((state) => state?.authtentication?.user)
	const { id, job_id } = useSelector((state) => state?.review?.review)

	const getTagName = (tagId) => {
		const tag = tags?.find((item) => item.id === tagId)
		return tag?.name || null
	}

	const getCurrentContext = () => {
		if (job_id) {
			return {
				name: CONTEXT_TYPE?.REVIEW,
				id: id,
			}
		} else if (selectedSearch?.id) {
			return {
				name: CONTEXT_TYPE?.SEARCH,
				id: selectedSearch?.id,
			}
		} else {
			return {
				name: CONTEXT_TYPE?.FILE,
				id: 0,
			}
		}
	}

	const handleRemoveTag = (tagData) => {
		if (tagData?.tag_id) {
			const currContext = getCurrentContext()
			dispatch(updateFileTag({ document_id: currFileId, tag_id: tagData?.tag_id, context_id: currContext?.id, type: "remove" }))
			closeDialog()
		}
	}

	const closeDialog = () => {
		setMultiTagDialogOpen(false)
		setMultiTagDialogData([])
		setCurrFileId(null)
	}

	return (
		<MultiTagDialog open={multiTagDialogOpen} title={t("tag.tagApplied")} onClose={closeDialog} dynamicClass={classes.multiTagDialog}>
			<List dense>
				{multiTagDialogData?.map((item, index) => {
					return (
						<ListItem key={`${item?.tag_id}-${index}`}>
							<ListItemText
								primary={getTagName(item?.tag_id)}
								title={getTagName(item?.tag_id)?.length > 20 ? getTagName(item?.tag_id) : false}
							/>
							<ListItemSecondaryAction
								title={!(item?.user_id === user?.userid) ? (item?.name?.length > 20 ? item?.name : false) : false}
							>
								{item?.user_id === user?.userid ? (
									<IconButton
										className={classes.removeTagButton}
										size="small"
										edge="end"
										onClick={() => handleRemoveTag(item)}
									>
										{t("tag.remove")}
									</IconButton>
								) : (
									<Typography className={classes.appliedBy} variant="body2" noWrap>
										{item?.name}
									</Typography>
								)}
							</ListItemSecondaryAction>
						</ListItem>
					)
				})}
			</List>
		</MultiTagDialog>
	)
}

export default ShowAllTags
